import React from 'react';

const DataDeletion = () => {
    // const handleDelete = () => {
    //     // Logic for data deletion
    // };

    return (
        <div>
            <h1>Data Deletion</h1>
            <p>If you’d like us to remove all personal data associated with your account, please send a request to <a href="mailto:jpantano30@gmail.com">jpantano30@gmail.com</a>. We will comply within 30 days.</p>
        </div>
    );
};

export default DataDeletion;